import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { SemanticPathService } from '@spartacus/core';
import { SsoLogin } from '../services/sso-login.service';

@Injectable({
  providedIn: 'root',
})

 export class SSOLoginGuard  {
  constructor(
    protected semanticPathService: SemanticPathService,
    protected router: Router,
    protected ssoLoginService: SsoLogin,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return of(route.queryParams?.['code']).pipe(
      take(1),
      switchMap((code): Observable<boolean | UrlTree> => {
        if (!code || !this.ssoLoginService.hasValidAuthorizationCallback()) {
          this.ssoLoginService.clearAuthorizationRequest();
          return of(this.router.parseUrl(this.semanticPathService.get('login') || '/login'));
        }
        // Wait for authorization to complete before allowing route activation
        return this.ssoLoginService.doSSOLogin(code).pipe(
          map((isAuthenticated: boolean) => {
            if (isAuthenticated) {
              // Only redirect to home if authenticated is true
              return true;
            } else {
              // Redirect to login page if authenticated is false
              return this.router.parseUrl(this.semanticPathService.get('login') || '/login');
            }
          }),
          catchError(() => {
            this.ssoLoginService.clearAuthorizationRequest();
            return of(this.router.parseUrl(this.semanticPathService.get('login') || '/login'));
          })
        );
      })
    );
  }

}